import type { InputHTMLAttributes, Ref } from 'react';
import field from '../Field/Field.module.css';

type TextInputProps = {
  invalid?: boolean;
  // React 19 accepts ref as a normal prop; forwarded so react-hook-form's register()
  // (and any caller needing the node) can attach to the underlying input.
  ref?: Ref<HTMLInputElement>;
} & InputHTMLAttributes<HTMLInputElement>;

export function TextInput({ invalid = false, className, ref, ...rest }: TextInputProps) {
  return (
    <input
      ref={ref}
      className={`${field.control} ${invalid ? field.errorControl : ''} ${className ?? ''}`}
      {...rest}
    />
  );
}
